import { AccredibleBaseThemeHelper } from '@accredible-frontend-v2/utils/base-theme-helper';

export class ThemeHelper extends AccredibleBaseThemeHelper {
  static getTheme(): string {
    return 'dashboard.accredible.com';
  }
}
